var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nuxt-error"},[_c(_vm.errorPage,{tag:"component",attrs:{"error":_vm.error}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }